import MovieList from './movie-list.vue'

export default MovieList;